import { formatter, request } from '@/utils/request';

export namespace EC {
  export const Path = {
    Search: '/expenseapi/ec/search',
    SearchForEc3: '/expenseapi/ec/searchEc3',
    Get: '/expenseapi/ec/get',
    Delete: '/expenseapi/ec/delete',
    Post: '/expenseapi/ec/post',
    GetEcStructures: '/expenseapi/ec/getEcStructures',
    GetEcStructuresWithBohq: '/expenseapi/ec/getEcStructuresWithBohq',
    QueryForSheet: '/expenseapi/ec/queryForSheet',
    ExportEc: '/expenseapi/ec/exportEc',
    ExportEcs: '/expenseapi/ec/exportEcs',
  };

  export async function searchEc3(body: API.EcItemSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.EC[]>>(Path.SearchForEc3, formatter(options));
  }

  export async function search(body: API.EcSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.EC[]>>(Path.Search, formatter(options));
  }

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.EC>>(Path.Get, formatter(options));
  }

  export async function del(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<any>>(Path.Delete, formatter(options));
  }

  export async function post(body: API.EC) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.EC>>(Path.Post, formatter(options));
  }

  export async function getPageGroups(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.PageGroup[]>>(
      '/expenseapi/ec/getPageGroups',
      formatter(options),
    );
  }

  export async function getPaymentMethods(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.DataOptions[]>>(
      '/expenseapi/ec/getPaymentMethods',
      formatter(options),
    );
  }
  export async function getPaymentMethodsByIds(ids: string) {
    const options = {
      method: 'GET',
      body: {
        ids: ids,
      },
    };
    return request<API.ResponseResult<API.DataOptions[]>>(
      '/expenseapi/ec/getPaymentMethodsByIds',
      formatter(options),
    );
  }


  export async function getExtendsBTs(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.DataOptions[]>>(
      '/expenseapi/ec/getExtendsBts',
      formatter(options),
    );
  }

  export async function getEcFieldConfigs() {
    const options = {
      method: 'GET',
      body: {},
    };
    return request<API.ResponseResult<API.EcFieldConfig[]>>(
      '/expenseapi/ec/getEcFieldConfigs',
      formatter(options),
    );
  }

  export async function getEcFieldConfigsByMetaType(metaType?: number) {
    const options = {
      method: 'GET',
      body: {
        metaType: metaType,
      },
    };
    return request<API.ResponseResult<API.EcFieldConfig[]>>(
      '/expenseapi/ec/getEcFieldConfigsByMetaType',
      formatter(options),
    );
  }

  export async function GetEcStructures(ecLevel?: number, pageTypeId?: number) {
    const options = {
      method: 'GET',
      body: {
        ecLevel: ecLevel,
        pageTypeId: pageTypeId,
      },
    };
    return request<API.ResponseResult<API.EcStructure[]>>(Path.GetEcStructures, formatter(options));
  }

  export async function GetEcStructuresWithBohq(body: API.EcStructureSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<Array<any>>>(
      Path.GetEcStructuresWithBohq,
      formatter(options),
    );
  }

  export async function queryForSheet(body: {
    ecLevel?: number;
    pageTypeId?: number;
    bohqId?: number;
    budgetProjectId?: number;
  }) {
    const options = {
      method: 'GET',
      body: body,
    };
    return request<API.ResponseResult<API.EcStructure[]>>(Path.QueryForSheet, formatter(options));
  }

  export async function exportEc() {
    const options = {
      method: 'GET',
      body: {},
    };
    return request<API.ResponseResult<Array<any>>>(Path.ExportEc, formatter(options));
  }

  export async function exPortEcs(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<Array<any>>>(Path.ExportEcs, formatter(options));
  }
}
